var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('loading')]:[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$error.handle(_vm.error))}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }